export const MESSAGE_TYPE_LOCATION = 1
export const MESSAGE_TYPE_IMAGE = 2
export const MESSAGE_TYPE_VIDEO = 5
export const MESSAGE_TYPE_DOCUMENT = 6

export interface UnwrappedReplyMessage {
  readonly id: string
  readonly type: ChatMessageType
  readonly replied: string
  readonly owner: string
  readonly text: string
}

export interface ChatAttachment {
  url: string
  fileName: string
  fileSize?: number
  error?: string
}

export declare type ChatMessage = {
  localId: string
  id: string
  type: ChatMessageType
  userId: string
  chatId: string
  ownerName: string
  ownerInitials: string
  text?: string
  originalText?: string
  date: number
  ownerId?: string
  location?: {lat: number; lng: number}
  image?: ChatAttachment
  video?: ChatAttachment
  file?: ChatAttachment
  localTranslated?: boolean
  isRead: boolean
  isDelivered: boolean
}

export type ChatMessageType =
  | 'text'
  | 'image'
  | 'video'
  | 'unknown'
  | 'location'
  | 'document'

export type ChatProduct = {
  id: string
  image: string
  title: string
  price: string
  status: string
}

export type ChatData = {
  id: string
  createdAt?: number
  title?: string
  avatar?: string
  newMessagesCount: number
  interlocutor: ChatParticipant
  lastMessage?: ChatMessage
  product?: ChatProduct
  isTranslatable: boolean
  messages?: ChatMessage[]
}

export type ChatParticipant = {
  readonly id: string
  readonly name?: string
  readonly surname?: string
  readonly avatarSrc?: string
  updatedAt?: number
  readonly onlineLastTime: number
  readonly online: boolean
  readonly langCode: string
}

export type WebSocketConnectionUser = {
  readonly token: string
  readonly hash: string
  readonly device_id: string
  readonly device_type: number
  readonly device_model: string
  readonly os_version: string
  readonly install_id: string
  readonly timezone_offset: number
}
